/**
 * Worksheet Goals Constants
 */

import { DISCIPLINE_ORDER, disciplineName } from './disciplines';

// Goals filter by one discipline or none; `all_disciplines` is this filter's
// own sentinel, not a discipline, so it is not in the shared map.
export const DISCIPLINE_OPTIONS: { value: string; label: string }[] = [
  { value: 'all_disciplines', label: 'All Disciplines' },
  ...DISCIPLINE_ORDER.map(discipline => ({
    value: discipline,
    label: `${discipline} - ${disciplineName(discipline)}`,
  })),
];
